import React,{useState,useEffect} from "react";
import QuickCreate from "../../../DetailView/components/quickCreate/quickCreate";
import CallIcon from '@material-ui/icons/Call';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';

import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import useStyles from "./styles";
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
export default function AddEditEvent({setIsSubpanelUpdated}){
  const classes = useStyles();
  const [direction, setDirection] = useState('up');
  const [openDashboardActions, setOpenDashboardActions] = useState(false);
  const [openQuickCreateDialog, setOpenQuickCreateDialog] = useState(false);
  const [whichQuickCreate, setWhichQuickCreate] = useState(null);
  const handleOpenQuickCreateDialog = (actionName) => {
    setOpenQuickCreateDialog(!openQuickCreateDialog);
    setWhichQuickCreate(actionName);
  };
  const DashboardActions = [
    { icon: <FormatListBulletedIcon />, name: 'Tasks', label: 'Create Task' },
    { icon: <PeopleAltIcon />, name: 'Meetings', label: 'Create Meeting' },
    { icon: <CallIcon />, name: 'Calls', label: 'Create Call' }
  ];
  const [value, setValue] = useState(0);
    const handleOpenDashboardActions = () => {
      setOpenDashboardActions(openDashboardActions ? false : true);

  };
  return(
    <>
    {openQuickCreateDialog ? <QuickCreate  calendarView={true} openQuickCreateDialog={openQuickCreateDialog} setOpenQuickCreateDialog={setOpenQuickCreateDialog} whichQuickCreate={whichQuickCreate} parent_name={""} parent_id={""} parent_type={module} setIsSubpanelUpdated={setIsSubpanelUpdated}
        value=""
        setValue="" /> : null}
    {DashboardActions.length? <SpeedDial
        ariaLabel="Detailview Actions"
        className={classes.speedDial}
        icon={<SpeedDialIcon />}
        onClick={handleOpenDashboardActions}
        open={openDashboardActions}
        direction={direction}
      >
        {DashboardActions.map((action) => (
          <SpeedDialAction
          
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.label}
            tooltipOpen
            onClick={() => handleOpenQuickCreateDialog(action.name)}
            classes={classes}
            TooltipClasses={classes}
          />
        ))}
      </SpeedDial>:null}
    </>
  )
}